export default {
  en: {
    client: 'Client',
    courier: 'Courier',
    restaurant: 'Restaurant',
    admin: 'Admin',
  },
  ru: {
    client: 'Клиент',
    courier: 'Курьер',
    restaurant: 'Ресторан',
    admin: 'Админ',
  },
}
